module.exports = __webpack_public_path__ + "img/2022-05-18_13-18-34.1eb515a6.jpg";